import detail from '../../api/detail'
import list from '../../api/list'
import router from '@/router'
import store from '..'
import i18n from '../../i18n.js' 
import Vue from "vue";
import _ from 'lodash';

const state = () => ({
  isSearching: false,
  addedToBasket: false,
  currentCategory: null,
  origin: "",
  categories: [],
  stateSelectedGold: '',
  selectedSku: '',
  // quantity: 1,
  retailPerc: 1,
  vat: 1,
  selectedJewel: {
    //object selected used in detail by the configuration selected
    images: null,
    placeholders: {},
    price: null,
    sku: "",
    quantity: 1,
    skuBase: "",
    jewelType: "",
    logo: false,
    writing: undefined,
    fastDelivery: false,
    warranty: false,
    rhodiumType: 'RHODIUM_NORMAL',
    singleAmount: 0,
    amount: 0,
    note: null,
  },
  optionsMap: {
    gold: "0",
    stoneColor: "stone",
    stoneSize: "size",
    size: "1",
    backing: "2",
    chain: "4",
    letter: "13",
  },
  optionsMapDefault: {
    chain: ["cv9-4-1", "cv9-4-3", "cv9-4-2"],
    gold1: ["1"],
    gold2: ["1"],
    gold3: ["1"],
    gold4: ["1"],
    size1: ["13"],
    size2: ["17", "17.5"],
  },
  imagesAvailable: [],
  videos: [],
  additionalValues: 0, //value additional based on logo and writing price
  additionalSkuLabelArray: [],
  preselectedJewel: {},
  selectedStoneObj: {},
  selectedStoneSizeObj: {},
  jewelDescription: "",
  jewelBillingDescription: "",
  logo: false, //logo engraving boolean
  writing: undefined, //customize engraving label
  fastDelivery: false, //fast delivery boolean
  warranty: false,
  preselectedLogo: false,
  preselectedWarranty: false,
  rhodiumType: 'RHODIUM_NORMAL',
  basePrice: 0,
  avgPrice: 0,
  currentJewelSelection: {
    //current jewel selected from the list and received from the BE
    name: "",
    description: "",
    images: null,
    keys: {},
    options: [
      {
        type: "",
        values: [
          {
            id: "",
            label: "",
            image: null,
          },
        ],
      },
    ],
  },
  stoneColorObj: {},
  stoneSizeObj: {},
});

// getters
const getters = {
  getPreselectedJewel: (state) => state.preselectedJewel,
};

// actions
const actions = {
  getValues({ commit }, sku) {
    commit("setSearching", true);
    detail.getValues((jewels) => {
      commit("setJewelOptions", jewels.data);
      setTimeout(() => {
        commit("setCurrentCategory");
      }, 200);
      setTimeout(() => {
        commit("setSearching", false);
      }, 500);
    }, sku);
  },
  getListCategories({ commit }, search) {
    list.getList((searchJewel) => {
      commit("setCurrentCategory", searchJewel);
    }, search);
  },
};

// mutations
const mutations = {
  setOrigin(state, value) {
    state.origin = value;
  },
  setCurrentCategory(state, values) {
    let val;
    if (values) {
      state.categories = values
      val = values.find(a => a.id === state.currentJewelSelection.categoryId)
    } else {
      val = state.categories.find(
        (a) => a.id === state.currentJewelSelection.categoryId
      );
    }
    state.currentCategory = Object.assign({}, val, null);
  },
  resetCurrentCategory(state, values) {
    state.currentCategory = null;
  },
  resetAdditionalSkuLabelArray(state) {
    state.additionalSkuLabelArray = [];
  },
  resetDetail(state) {
    // state.isSearching = false;
    state.quantity = 1;
    state.addedToBasket = false;
    state.selectedSku = "";
    state.selectedJewel = {
      //object selected used in detail
      images: null,
      placeholders: {},
      price: null,
      sku: "",
      quantity: 1,
      skuBase: "",
      jewelType: "",
      logo: false,
      writing: undefined,
      fastDelivery: false,
      warranty: false,
      rhodiumType: 'RHODIUM_NORMAL',
      singleAmount: 0,
      amount: 0,
      note: null,
    };
    state.optionsMap = {
      gold: "0",
      stoneColor: "stone",
      stoneSize: "size",
      size: "1",
      backing: "2",
      chain: "4",
      letter: "13",
    };
    state.optionsMapDefault = {
      chain: ["cv9-4-1", "cv9-4-3", "cv9-4-2"],
      gold1: ["1"],
      gold2: ["1"],
      gold3: ["1"],
      gold4: ["1"],
      size1: ["13"],
      size2: ["17", "17.5"],
      size19: ["13"],
      gold19: ["3"],
      gold20: ["3"],
      gold21: ["3"],
      gold22: ["3"],
      gold23: ["1"],
      gold24: ["1"],
      gold25: ["1"],
      size23: ["13"]
    };
    state.imagesAvailable = [];
    state.videos = [];
    state.additionalValues = 0; //value additional based on logo and writing price
    state.additionalSkuLabelArray = [];
    state.selectedStoneObj = {};
    state.selectedStoneSizeObj = {};
    state.jewelDescription = "";
    state.jewelBillingDescription = "";
    state.logo = false; //logo engraving boolean
    state.writing = undefined;  //customize engraving label
    state.fastDelivery = false; //fast delivery boolean
    state.warranty = false;
    state.preselectedLogo = false;
    state.preselectedWarranty = false;
    state.rhodiumType = 'RHODIUM_NORMAL';
    state.basePrice = 0;
    state.avgPrice = 0;
    state.currentJewelSelection = {
      //current jewel select by sku base
      name: "",
      description: "",
      images: null,
      keys: {},
      options: [
        {
          type: "",
          values: [
            {
              id: "",
              label: "",
              image: null,
            },
          ],
        },
      ],
    };
    state.stoneColorObj = {};
    state.stoneSizeObj = {};
  },
  setSearching(state, value) {
    //searching boolean value that shows the loader if there's a check
    state.isSearching = value;
  },
  setLogoWriting(state, value) {
    //this function sets logo, writing and rhodiumType based on the value and change the sku by the rhodium type
    state[value.label] = value.value;
    state.addedToBasket = false;
    if (value.label === "logo") {
      Vue.set(state.additionalSkuLabelArray, 1, null);
      if (value.value) {
        Vue.set(state.additionalSkuLabelArray, 1, "-l");
      }
    }
    if (value.label === "writing") {
      Vue.set(state.additionalSkuLabelArray, 2, undefined);
      if (value.value) {
        Vue.set(state.additionalSkuLabelArray, 2, `-w`);
      }
    }
    if (value.label === "rhodiumType") {
      if (value.value === "TIPS_BLUING") {
        Vue.set(state.additionalSkuLabelArray, 0, null);
        if (value.value) {
          Vue.set(state.additionalSkuLabelArray, 0, "-tb");
        }
      } else if (value.value === "RHODIUM_BLACK") {
        Vue.set(state.additionalSkuLabelArray, 0, null);
        if (value.value) {
          Vue.set(state.additionalSkuLabelArray, 0, "-rb");
        }
      } else {
        Vue.set(state.additionalSkuLabelArray, 0, null);
      }
      // the price and the average price change based on the rhodium type selected
      state.basePrice = state.selectedJewel.optionPrice.find(
        (a) => a.rhodiumType === state[value.label]
      ).price;
      state.avgPrice = state.selectedJewel.optionPrice.find(
        (a) => a.rhodiumType === state[value.label]
      ).averagePrice;
    }
    if (value.label === 'fastDelivery') {
      Vue.set(state.additionalSkuLabelArray, 3, undefined)
      if (value.value) {
        Vue.set(state.additionalSkuLabelArray, 3, `-pc`)
      }
    }
    if (value.label === 'warranty') {
      Vue.set(state.additionalSkuLabelArray, 4, undefined)
      if (value.value) {
        Vue.set(state.additionalSkuLabelArray, 4, `-wa`)
      }
    }
  },

  // this function set the quantity of jewel in the detail
  setQuantity(state, value) {
    state.quantity = parseInt(value);
  },

  // this functions set the retail percentage that arrives from Magento
  setRetailPerc(state, value) {
    state.retailPerc = parseFloat(value);
  },
  // this functions set the retail percentage that arrives from Magento
  setVat(state, value) {
    state.vat = parseFloat(value);
  },

  setJewelOptions(state, jewel) {
    state.currentJewelSelection = jewel;

    state.currentJewelSelection.fastDeliveryDate = Vue.formatShipmentDate(state.currentJewelSelection.fastDeliveryDate);
    state.imagesAvailable = [];
    state.videos = [];
    state.additionalValues = 0;
    state.basePrice = 0;
    state.avgPrice = 0;

    for (const key in state.currentJewelSelection.keys) {
      if (state.currentJewelSelection.keys.hasOwnProperty(key)) {
        if (state.currentJewelSelection.keys[key].images) {
          state.imagesAvailable = state.currentJewelSelection.keys[key].images;
        } else {
          state.imagesAvailable.push("");
        }
        
        if (state.currentJewelSelection.keys[key].videos) {
          state.videos = state.currentJewelSelection.keys[key].videos;
        }
        else {
          state.videos.push("");
        }
      }
    }
    state.imagesAvailable = [...new Set(state.imagesAvailable)];
    state.videos = [...new Set(state.videos)];

    state.selectedStoneSizeObj = {};
    state.selectedStoneObj = {};
    state.jewelDescription = "";
    state.jewelBillingDescription = "";
    jewel.options.forEach((el) => {
      if (el.type === "stoneColor") {
        state.stoneColorObj[`stoneColor${el.stoneNumber}`] = {
          values: el.values,
          type: el.stoneNumber,
        };
      }
    });
    state.stoneSizeObj = {};
    state.jewelDescription = "";
    state.jewelBillingDescription = "";
    state.preselectedLogo = state.currentJewelSelection.preselectedJewelOptions?.includes("LOGO");
    state.preselectedWarranty = state.currentJewelSelection.preselectedJewelOptions?.includes("WARRANTY");

    jewel.options.forEach((el) => {
      //mappa per ciclare su tutte le possibili stone size e mostrarle
      if (el.type === "stoneSize") {
        state.stoneSizeObj[`stoneSize${el.stoneNumber}`] = {
          values: el.values,
          type: el.stoneNumber,
          stoneType: el.stoneType,
          sizeUnit: el.sizeUnit,
        };
      }
    });

    jewel.options.forEach((el) => {
      if (
        el.values.length > 0 &&
        el.type !== "stoneSize" &&
        el.type !== "stoneColor"
      ) {
        el.values.sort(function(a, b) {
          return a.id - b.id || a.label.localeCompare(b.label);
        });
      }
    });
  },
  setStateGold(state, value) {
    state.stateSelectedGold = value;
  },
  setAddedToBasket(state, value) {
    state.addedToBasket = value;
  },
  setSelectedStoneObj(state, obj) {
    if (state.selectedStoneObj[obj.type]) {
      delete state.selectedStoneObj[obj.type];
    }
    Vue.set(state.selectedStoneObj, obj.type, null);
    Vue.set(state.selectedStoneObj, obj.type, obj.value);
  },
  resetStoneObj(state) {
    state.selectedStoneObj = {}
    state.stoneColorObj = {}
  },
  resetSelectedStoneObj(state) {
    state.selectedStoneObj = {}
  },
  resetCurrentJewel(state) {
    state.currentJewelSelection = {
      name: "",
      description: "",
      images: null,
      keys: {},
      options: [
        {
          type: "",
          values: [
            {
              id: "",
              label: "",
              image: null,
            },
          ],
        },
      ],
    };
    state.selectedJewel = {};
    state.selectedSku = "";
    state.jewelDescription = "";
    state.jewelBillingDescription = "";
  },
  setSelectedStoneSizeObj(state, obj) {
    if (state.selectedStoneSizeObj[obj.type]) {
      delete state.selectedStoneSizeObj[obj.type];
    }
    Vue.set(state.selectedStoneSizeObj, obj.type, null);
    Vue.set(state.selectedStoneSizeObj, obj.type, obj.value);
  },
  resetSelectedStoneSizeObj(state) {
    state.selectedStoneSizeObj = {};
    state.stoneSizeObj = {};
  },
  changePrice(state, price) {
    state.additionalValues = state.additionalValues + price;
  },
  setPreselectedJewel(state, jewelSelection) {
    // if (jewelSelection
    //   && Object.keys(jewelSelection).length === 0 && jewelSelection.constructor === Object)
    state.additionalSkuLabelArray = [];
    state.preselectedJewel = jewelSelection;
  },
  addValuesToSelected(state, obj) {
    if (state.selectedJewel) {
      state.selectedJewel.description = state.jewelDescription
      state.selectedJewel.billingDescription = state.jewelBillingDescription
      const isPluginB2C = store.getters['config/isPluginB2C']
      if (state.fastDelivery)
        state.selectedJewel.deliveryDate = state.currentJewelSelection.fastDeliveryDate;
      else if (isPluginB2C)
        state.selectedJewel.deliveryDate = state.selectedJewel.b2cDeliveryDate;
      else if (state.logo || state.writing)
        state.selectedJewel.deliveryDate = state.selectedJewel.engravingDate
      else
        state.selectedJewel.deliveryDate = state.selectedJewel.shipmentDate
      state.selectedJewel.name = state.currentJewelSelection.name
      state.selectedJewel.productType = state.currentJewelSelection.productType
      state.selectedJewel.quantity = parseInt(obj.qnt)
      state.selectedJewel.writing = state.writing
      state.selectedJewel.logo = state.logo
      state.selectedJewel.sku = state.selectedSku + state.additionalSkuLabelArray.join("")
      state.selectedJewel.skuBase = router.currentRoute.params.sku
      state.selectedJewel.rhodiumType = state.rhodiumType
      state.selectedJewel.fastDelivery = state.fastDelivery
      let price = state.retailPerc > 1 ? (state.basePrice + state.additionalValues) * obj.qnt * state.retailPerc : (state.basePrice + state.additionalValues) * obj.qnt
      state.selectedJewel.price = parseFloat(price.toFixed(2))
      let singleAmount = state.retailPerc > 1 ? (state.basePrice + state.additionalValues) * state.retailPerc : state.basePrice + state.additionalValues
      state.selectedJewel.singleAmount = parseFloat(singleAmount.toFixed(2))
      let amount = state.retailPerc > 1 ? (state.basePrice + state.additionalValues) * obj.qnt * state.retailPerc : (state.basePrice + state.additionalValues) * obj.qnt
      state.selectedJewel.amount = parseFloat(amount.toFixed(2))
      state.selectedJewel.note = obj.note;

      if (state.currentJewelSelection.certifiedDiamondBundle) {
        let certifiedDiamondBundle = state.currentJewelSelection.certifiedDiamondBundle;
        let settingItem = _.cloneDeep(state.selectedJewel);
        settingItem.price -= certifiedDiamondBundle.totalAmount;
        settingItem.singleAmount -= certifiedDiamondBundle.totalAmount;
        settingItem.amount -= certifiedDiamondBundle.totalAmount;
        state.selectedJewel.bundleItems = [settingItem, ...certifiedDiamondBundle.cartItems]
        state.selectedJewel.sku += "|" + certifiedDiamondBundle.id;
        state.selectedJewel.name += " - " + certifiedDiamondBundle.name;
        state.selectedJewel.description += " - " + certifiedDiamondBundle.description;
      }
    }
  },
  addValueToJewel(state, obj) {
    if (state.selectedJewel) {
      state.selectedJewel[obj.category] = obj.value;
    }
  },
  setValueAndChangeRing(state, obj) {
    state.addedToBasket = false;
    state.selectedJewel = state.currentJewelSelection.keys[obj.sku] ? JSON.parse(JSON.stringify(state.currentJewelSelection.keys[obj.sku])) : undefined;
    state.selectedSku = state.currentJewelSelection.keys[obj.sku] ? state.currentJewelSelection.keys[obj.sku].sku : ''
    if (state.selectedJewel) {
      state.selectedJewel.engravingDate = Vue.formatShipmentDate(state.selectedJewel.engravingDate);
      state.selectedJewel.shipmentDate = Vue.formatShipmentDate(state.selectedJewel.shipmentDate);
      state.selectedJewel.b2cDeliveryDate = Vue.formatShipmentDate(state.selectedJewel.b2cDeliveryDate);

      state.basePrice = state.selectedJewel.optionPrice.find(
        (a) => a.rhodiumType == null || a.rhodiumType === state.rhodiumType
      ).price;
      state.avgPrice = state.selectedJewel.optionPrice.find(
        (a) => a.rhodiumType == null || a.rhodiumType === state.rhodiumType
      ).averagePrice;
    } else {
      state.basePrice = 0;
      state.avgPrice = 0;
    }

    /**
     *
     * REPLACING PLACEHOLDERS IN DESCRIPTION
     *
     */
    var reg = /{(.*?)}/g;
    var found;
    var foundBilling;
    if (state.selectedJewel) {
      state.jewelDescription = state.currentJewelSelection.description;
      state.jewelBillingDescription =
        state.currentJewelSelection.billingDescription;
      while ((found = reg.exec(state.currentJewelSelection.description))) {
        if (state.selectedJewel.placeholders[found[1]]) {
          state.jewelDescription = state.jewelDescription.replace(
            `${found[0]}`,
            state.selectedJewel.placeholders[found[1]]
          );
        }
      }
      if (state.currentJewelSelection.billingDescription) {
        while (
          (foundBilling = reg.exec(
            state.currentJewelSelection.billingDescription
          ))
        ) {
          if (state.selectedJewel.placeholders[foundBilling[1]]) {
            state.jewelBillingDescription = state.jewelBillingDescription.replace(
              `${foundBilling[0]}`,
              state.selectedJewel.placeholders[foundBilling[1]]
            );
          } else {
            state.jewelBillingDescription = state.jewelBillingDescription.replace(
              foundBilling[0],
              "--"
            );
          }
        }
      }
    } else {
      state.jewelDescription = "";
      state.jewelBillingDescription = "";
    }

    /**
     *
     * GET ALL THE AVAILABLE CONFIGURATION IN THE JEWEL
     *
     */

    // create an object <key,value> where the keys are the configuration keys
    const keysList = Object.assign({}, state.currentJewelSelection.keys);

    // create a field k as an array within the configuration parameters in each element of keysList
    Object.keys(keysList).map((key, index) => {
      const k = key.split("|");
      const o = keysList[key];
      o.k = k;
    });

    for (
      let index = 0;
      index < state.currentJewelSelection.options.length;
      index++
    ) {
      var temp = state.currentJewelSelection.options[index].values;
      state.currentJewelSelection.options[index].values = undefined;
      temp.forEach((el) => {
        el.disabled = false;
      });
      state.currentJewelSelection.options[index].values = temp;
    }

    const valuesInSku = obj.sku.split("|");

    // list is an array of all values of the keyList map
    var listValues = Object.values(keysList);
    for (let i = 0; i < valuesInSku.length; i++) {
      if (valuesInSku[i] !== "null") {
        var list1 = listValues.filter((e) => e.k[i] === valuesInSku[i]);

        for (
          let index = 0;
          index < state.currentJewelSelection.options.length;
          index++
        ) {
          if (index !== i) {
            const listMap = list1.map((e) => e.k[index]);
            const distinct = (value, index, self) => {
              return self.indexOf(value) === index;
            };
            var list2 = listMap.filter(distinct);
            const t = state.currentJewelSelection.options[index].values;
            state.currentJewelSelection.options[index].values = undefined;
            t.forEach((element) => {
              let valueToCheck = element.id.replace(
                "{gt}",
                state.stateSelectedGold
              );
              if (list2.includes(valueToCheck) || (state.currentJewelSelection.options[index].type == 'gold' && 
                (state.currentJewelSelection.options[i].type == 'chain' || state.currentJewelSelection.options[i].type == 'backing'))) {
                // do nothing
              } else {
                element.disabled = true;
              }
            });
            state.currentJewelSelection.options[index].values = t;
          }
        }
      }
    }
    let toAllElements = listValues;
    state.imagesAvailable = [];
    state.videos = [];
    for (let i = 0; i < valuesInSku.length; i++) {
      if (valuesInSku[i] !== "null") {
        toAllElements = toAllElements.filter((e) => e.k[i] === valuesInSku[i]);
      }
    }
    toAllElements.forEach((element) => {
      state.imagesAvailable = state.imagesAvailable.concat(element.images);
      state.videos = state.videos.concat(element.videos);
    });
    state.imagesAvailable = [...new Set(state.imagesAvailable)];
    state.videos = [...new Set(state.videos)];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
